import { Input } from "@comps/ui/input";
import { FieldFormatSectionProps } from "./FieldFormatSection";
import { TW_CheckboxCell_not_selected, TW_CheckboxCell_selected, TW_FieldFormatSectionLine, TW_FieldFormatSectionLine_Label, TW_FieldFormatSectionLine_Select, TW_FieldFormatSectionLine_TextInput } from "@utils/twClasses";
import { useTranslation } from "react-i18next";
import { CURRENCY_DEFAULT_SYMBOL, CURRENCY_DEFAULT_SYMBOL_BEFORE, DEFAULT_NUMBER_FORMAT } from "@utils/constants";
import { NUMBER_FORMATS } from "@utils/types";


export function CurrencyFieldFormatSection({ format, onFormatChange }: FieldFormatSectionProps) {

    const { t } = useTranslation();

    const symbol = (format && format.get("symbol")) ? format.get("symbol") : CURRENCY_DEFAULT_SYMBOL;
    const symbolBefore = (format && format.get("before") === true ) ? true : CURRENCY_DEFAULT_SYMBOL_BEFORE;
    const numberFormat = (format && format.get("numberFormat")) ? format.get("numberFormat") : DEFAULT_NUMBER_FORMAT;
    const decimalPlaces = (format && format.get("decimalPlaces")) ? format.get("decimalPlaces") : "";

    return (
        <>
            <div className={TW_FieldFormatSectionLine}>
                <p className={TW_FieldFormatSectionLine_Label}>{t("field.format.decimal.numberFormat.label")}</p>
            
                <select className={TW_FieldFormatSectionLine_Select} value={numberFormat} onChange={onFormatChange("numberFormat", false)}>
                    {Array.from(NUMBER_FORMATS).map(([key, value]) => {
                        let i18nKey = "number.format.description." + key;
                        return <option key={"number-format-" + key} value={value} className="text-base">{t(i18nKey)}</option>
                    })}
                </select>
            </div>

            <div className={TW_FieldFormatSectionLine}>
                <p className={TW_FieldFormatSectionLine_Label}>{t("field.format.decimal.decimalPlaces.label")}</p>
                <Input className={TW_FieldFormatSectionLine_TextInput + " w-10"} pattern="\d*" placeholder="2" value={decimalPlaces} onChange={onFormatChange("decimalPlaces", false)} />
            </div>

            <div className={TW_FieldFormatSectionLine}>
                <p className={TW_FieldFormatSectionLine_Label}>{t("field.format.currency.symbol.label")}</p>
                <Input className={TW_FieldFormatSectionLine_TextInput + " w-10"} placeholder="€" value={symbol} onChange={onFormatChange("symbol", false)} />
            </div>
            
            <div className={TW_FieldFormatSectionLine}>
                <p className={TW_FieldFormatSectionLine_Label}>{t("field.format.currency.before.label")}</p>
                <Input className={(symbolBefore ? TW_CheckboxCell_selected : TW_CheckboxCell_not_selected) } type="checkbox" checked={symbolBefore} onChange={onFormatChange("before", true)} />
            </div>
        </>
    )
}
